import { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import { deepCopy } from '../../../../../util/Utils'
import { getJobResultsQueries, passThrough } from '../../../../../services/toolsService'
import useNotifications from '../../../../../hooks/useNotifications'

export default () => {}

export function useResultsQueriesList(jobId) {
  const { t } = useTranslation()
  const { error } = useNotifications()

  const initialState = {
    resultsQueries: [],
  }

  const reducer = (_, currentState) => deepCopy(currentState)

  const [resultsQueriesListState, setResultsQueriesListState] = useReducer(reducer, initialState)
  const resultsQueriesListActions = {
    updateResultsQueriesListState: () => {
      setResultsQueriesListState(resultsQueriesListState)
    },
    setResultsQueries: (resultsQueries) => {
      resultsQueriesListState.resultsQueries = resultsQueries || []
      resultsQueriesListActions.updateResultsQueriesListState()
    },
    addResultQuery: (resultQuery) => {
      resultsQueriesListState.resultsQueries.push(resultQuery)
      resultsQueriesListActions.updateResultsQueriesListState()
    },
    fetchResultsQueries: () => {
      getJobResultsQueries(jobId).then((data) => {
        resultsQueriesListActions.setResultsQueries(data.queries)
      })
    },
    formatColumnsAndRowsForUI: (resultsQuery) => {
      const columns = {}
      const rows = {}

      // columns
      if (resultsQuery.outputColumns) {
        if (resultsQuery.outputColumnsIsAWhiteList) {
          columns.include = resultsQuery.outputColumns.map((outputColumn) => {
            return outputColumn.name
          })
        } else {
          columns.exclude = resultsQuery.outputColumns.map((outputColumn) => {
            return outputColumn.name
          })
        }
      }
      // Rows Request
      if (resultsQuery.requestItemFilter) {
        const requestContain = resultsQuery.requestItemFilter.valuesThatContain
        const requestNoContain = resultsQuery.requestItemFilter.valuesThatDoNotContain
        Object.keys(requestContain).forEach((column) => {
          requestContain[column].forEach((value) => {
            rows.contain = rows.contain || []
            rows.contain.push({ column, value })
          })
        })
        Object.keys(requestNoContain).forEach((column) => {
          requestNoContain[column].forEach((value) => {
            rows.noContain = rows.noContain || []
            rows.noContain.push({ column, value })
          })
        })
      }
      if (resultsQuery.responseItemFilter) {
        if (!resultsQuery.responseItemFilter.successExcluded && !resultsQuery.responseItemFilter.failureExcluded) {
          rows.endResult = 'All Items'
        } else if (resultsQuery.responseItemFilter.successExcluded) {
          rows.endResult = 'Failed Items Only'
        } else if (resultsQuery.responseItemFilter.failureExcluded) {
          rows.endResult = 'Successful Items Only'
        }
        // Rows Response
        const responseContain = resultsQuery.responseItemFilter.valuesThatContain
        const responseNoContain = resultsQuery.responseItemFilter.valuesThatDoNotContain
        Object.keys(responseContain).forEach((column) => {
          responseContain[column].forEach((value) => {
            rows.contain = rows.contain || []
            rows.contain.push({ column, value })
          })
        })
        Object.keys(responseNoContain).forEach((column) => {
          responseNoContain[column].forEach((value) => {
            rows.noContain = rows.noContain || []
            rows.noContain.push({ column, value })
          })
        })
      }

      return { columns, rows }
    },
    hitEndpoint: (href, method, body) => {
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
      passThrough(href, method, body, headers)
        .then(() => {
          resultsQueriesListActions.fetchResultsQueries()
        })
        .catch((err) => {
          error(t('tools.failedResultsquery.operation', 'Failed ResultsQuery Operation'), err)
        })
    },
  }
  return { resultsQueriesListState, resultsQueriesListActions }
}
